import HeaderWidget from '../../../../common/components/molecule/HeaderWidget/HeaderWidget'
import StreetLightList from '../../../../features/planBT/components/Streetlight/StreetlightList'

export default function StreetLightListPage() {
  return (
    <div style={{color: 'white'}}>
        <HeaderWidget>Lampadaires</HeaderWidget>
        <StreetLightList.AddBtn />
        <StreetLightList.List />
    </div>
  )
}
